import { gql } from '@apollo/client';

export const ACTIVITY_LOG_FIELDS = gql`
    fragment ActivityLogFields on order_activity_logs {
        entity_id
        entity_type
        log_detail
        log_id
        log_message
        log_type
        field
        prev_date
        curr_date
        prev_at
        curr_at
        prev_end
        curr_end
        prev_text
        curr_text
        reschedule_reason_code
        is_error
        order_id
        private_admin
        private_client_id
        timestamp
        source_user_id
        source_integration
        source_integration_provided
        source_channel
        user {
            user_id
            username
        }
    }
`;
